import { render } from "./XSetting.vue?vue&type=template&id=3f394cc0&scoped=true"
import script from "./XSetting.vue?vue&type=script&lang=js"
export * from "./XSetting.vue?vue&type=script&lang=js"

import "./XSetting.vue?vue&type=style&index=0&id=3f394cc0&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f394cc0"]])

export default __exports__